import apiConfig from "../../apiConfig";

export const getAgentDetails = async (at, agentId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/AGENTS/GET_AGENT_DETAILS",
		{ Agent_Id: agentId },
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
